/**
* Product Filter JS
* -----------------------------------------------------------------------------
*
* All the JS for the Product Filter component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'product-filter',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      let levelOneCategory = $( '.product-filter .level--one select' ).val();
      let levelTwoCategory = $( '.product-filter .level--two .field[data-category="' + levelOneCategory + '"] select' ).val();
      let deepestCategoryUrl = '';
      updateFilters();

      $( '.product-filter .level--one select, .product-filter .level--two select, .product-filter .level--three select' ).on( 'change', function() {
        updateFilters();
      } );

      function updateFilters() {
        levelOneCategory = $( '.product-filter .level--one select' ).val();
        levelTwoCategory = $( '.product-filter .level--two .field[data-category="' + levelOneCategory + '"] select' ).val();

        $( '.product-filter .level--two .field, .product-filter .level--three .field' ).hide();

        if ( $( '.product-filter .level--two .field[data-category="' + levelOneCategory + '"]' ).length == 0 ) {
          $( '.product-filter .level--two' ).addClass( 'is-empty' );
        } else {
          $( '.product-filter .level--two .field[data-category="' + levelOneCategory + '"]' ).show();
          $( '.product-filter .level--two' ).removeClass( 'is-empty' );
        }

        if ( $( '.product-filter .level--three .field[data-category="' + levelTwoCategory + '"]' ).length == 0 ) {
          $( '.product-filter .level--three' ).addClass( 'is-empty' );
        } else {
          $( '.product-filter .level--three .field[data-category="' + levelTwoCategory + '"]' ).show();
          $( '.product-filter .level--three' ).removeClass( 'is-empty' );
        }

        if ( $( '.product-filter .level--three:not(.is-empty) .field:visible' ).length !== 0 ) {
          deepestCategoryUrl = $( '.product-filter .level--three .field:visible select option:selected' ).attr( 'data-url' );
          console.log( '3' );
        } else if ( $( '.product-filter .level--two:not(.is-empty) .field:visible' ).length !== 0 ) {
          deepestCategoryUrl = $( '.product-filter .level--two .field:visible select option:selected' ).attr( 'data-url' );
          console.log( '2' );
        } else {
          deepestCategoryUrl = $( '.product-filter .level--one .field:visible select option:selected' ).attr( 'data-url' );
          console.log( '1' );
        }

        $( '.product-filter .category-search' ).attr( 'href', deepestCategoryUrl );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'product-filter', COMPONENT );
} )( app );
